import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <>
      {window.location.pathname.startsWith('/fbmanager/main') ? null : (
        <section className="center-page">
          <Result
            status="404"
            title="404"
            subTitle="Извините, скорее всего такой страницы не существует"
            extra={
              <Button type="primary" onClick={() => navigate('/me')}>
                Перейти в профиль
              </Button>
            }
          />
        </section>
      )}
    </>
  );
}
